/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import YearFilterCard from '../../../../common/components/YearFilterCard/YearFilterCard';
import _ from 'lodash';
interface propsType {
  claimData: any;
  airTicketsData: any;
  isLoading?: boolean;
  setFilterYear: (data: number) => void;
  trans?: any;
}
import moment from 'moment';
import ClaimHistoryTile from '../../../../common/components/ClaimHistoryTile/ClaimHistoryTile';
import AirTicketTile from '../../../../common/components/AirTicketTile/AirTicketTile';
import ClaimViewModalController from '../../../../common/Modals/Claims/ClaimViewModal/ClaimViewModalController';
import AirTicketViewModalContoller from '../../../../common/Modals/Claims/AirTicketViewModal/AirTicketViewModalContoller';
import {
  getPreviousYears,
} from '../../../../common/configs/utils';
import Loader from '../../../../common/Lottifiers/Loader/Loader';


const ClaimHistoryPresenter: React.FC<propsType> = ({
  claimData,
  airTicketsData,
  setFilterYear,
  isLoading,
  trans,
}) => {
  const [openAirTicketModal, setOpenAirTicketModal] = useState(false);
  const [openClaimModal, setOpenClaimModal] = useState(false);

  const [yearTitle, setyearTitle] = useState(moment(new Date()).format('YYYY'));
  const [claimHistoryViewData, setClaimHistoryViewData] = useState({});
  const [airTicketHistoryViewData, setAirTicketHistoryViewData] = useState({});

  const handleSelectyear = (year: any) => {
    setyearTitle(year.label);
    setFilterYear(year.id);
  };
  return (
    <div>
      <YearFilterCard
        card_height="628px"
        card_title={trans('Claim History')}
        onYearSelect={handleSelectyear}
        yearMenu={getPreviousYears()}
        yearTitle={yearTitle}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {_.map(claimData, (claim) => {
              return (
                <ClaimHistoryTile
                  claimName={claim?.claim_type?.name}
                  travelDate={claim?.date}
                  amount={claim?.amount}
                  status={claim?.status}
                  onClick={() => {
                    setOpenClaimModal(true);
                    setClaimHistoryViewData(claim);
                  }}
                  trans={trans}
                />
              );
            })}
            {_.map(airTicketsData, (air) => {
              return (
                <AirTicketTile
                  ticketName={air?.trip_type?.name}
                  startDate={air?.date}
                  endDate={
                    air?.return_date == '' || air?.return_date == '0000-00-00'
                      ? '--'
                      : air?.return_date
                  }
                  applicant={trans(air?.ticket_for)}
                  status={air?.status}
                  onClick={() => {
                    setOpenAirTicketModal(true);
                    setAirTicketHistoryViewData(air);
                  }}
                />
              );
            })}
          </div>
        )}
      </YearFilterCard>

      {/* Claim History View Modal */}

      {openClaimModal && (
        <ClaimViewModalController
          isModalOpen={openClaimModal}
          closeModal={() => setOpenClaimModal(false)}
          claimViewData={claimHistoryViewData}
        />
      )}
      {/* Air Ticket History View Modal */}

      {openAirTicketModal && (
        <AirTicketViewModalContoller
          isModalOpen={openAirTicketModal}
          closeModal={() => setOpenAirTicketModal(false)}
          airticketViewData={airTicketHistoryViewData}
        />
      )}
    </div>
  );
};

export default ClaimHistoryPresenter;
